<div class="bottomnav">
    <div class="footer-right">
        <a routerLink="datenschutz">Privacy Policy / Datenschutzerklärung</a>
        <a routerLink="impressum">Contact / Impressum</a>
    </div>
    <a class="copyright">© ARTISTIC REVOLUTION Records, 2022</a>
</div>